import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';

export const Container = styled('div', {
  gap: '32px',
  backgroundColor: '$core.color.neutral.0',
});

export const TabContainer = styled('div', {
  color: '$core.color.brand.100',
  padding: '0px',
});

export const TabsContainer = styled(Tabs, {
  dynamic: ({ cssProps: { isMapView } = {} }) => ({
    '.abyss-tabs-list': {
      borderStyle: 'solid',
      borderColor: '$cardBorder',
      borderWidth: '1px 0px 1px 0px ',
      '& > div': {
        gap: '20px',
      },
      '@media (max-width: 464px)': {
        display: isMapView ? 'none' : 'flex',
      },
    },
  }),

  '.abyss-tabs-tab': {
    backgroundColor: 'white',
    border: 'none',
  },

  '.abyss-tabs-extended-border': {
    border: 'none',
  },

  '.abyss-tabs-content-container': {
    borderWidth: '0px 0px 0px 0px',
    padding: '0px',
  },
  '.abyss-tabs-tab-content': {
    fontSize: '$lg',
    fontWeight: 'bold',
    lineHeight: '$lg',
    textAlign: 'center',
  },
  '.abyss-tabs-tab-active-line': {
    borderColor: '$core.color.neutral.80',
    borderRadius: '6px 6px 0px 0px',
  },
  '.abyss-tabs-list': {
    overflowX: 'auto',
    textWrap: 'nowrap',
    button: {
      minWidth: 'unset',
      padding: '32px $md $sm 12px',
      '&:first-of-type': {
        paddingLeft: '0',
      },
    },

    paddingLeft: 'calc((100% - 1200px) / 2)',
    paddingRight: 'calc((100% - 1200px) / 2)',

    '@media (max-width: 1248px)': {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
    '@media (max-width: 744px)': {
      paddingLeft: '16px',
      paddingRight: '16px',
      scrollBehavior: 'smooth',
      scrollbarColor: 'transparent transparent',
      '&.hide-scrollbar': {
        overflow: 'auto',
        scrollBehavior: 'smooth',
        '&.hide-scrollbar::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
  },
});

export const ContainerForAllSectionsStyled = styled('div', {
  dynamic: ({ cssProps: { display = 'block' } = {} }) => ({
    display,
  }),
  borderBottom: '1px solid $cardBorder',
  borderLeft: 'none',
  borderRight: 'none',
});

export const browseServiceHeader = {
  'abyss-heading-root': {
    paddingTop: 20,
    marginBottom: '$sm',
    '@media (max-width: 744px)': {
      fontSize: '$medium !important',
      lineHeight: '$lg !important',
    },
  },
};

export const DisclaimerContainer = styled('div', {
  dynamic: ({
    cssProps: { ratingSection, umrMember, enableMapViewHideOption } = {},
  }) => ({
    borderTop:
      ratingSection || enableMapViewHideOption
        ? '0 !important'
        : '1px solid $cardBorder',
    marginTop: umrMember ? '8px' : 0,
  }),
  borderLeft: 'none',
  borderRight: 'none',
  '@media (max-width: 464px)': {
    paddingRight: '8px',
  },
});

export const VisionCareHeader = {
  'abyss-heading-root': {
    '@media (max-width: 744px)': {
      fontSize: '$medium !important',
      lineHeight: '$lg !important',
    },
  },
};

export const TerminationWrapper = styled('div', {
  dynamic: ({ cssProps: { isPCP } = {} }) => ({
    '.abyss-alert-icon-container': {
      alignSelf: isPCP ? 'auto' : 'center',
    },

    '.abyss-alert-container': {
      border: '0',
      padding: '8px 8px 8px 24px',
      minHeight: isPCP ? '72px' : '36px',
    },
    '@media (max-width: 744px)': {
      '.abyss-alert-container': {
        padding: '8px 8px 8px 16px',
      },
    },
  }),

  '.abyss-alert-header-container': {
    paddingRight: 'calc((100% - 1200px) / 2)',
    paddingLeft: 'calc((100% - 1200px) / 2)',
  },

  '.abyss-icon-symbol': {
    width: '20px',
    height: '20px',
  },

  '.abyss-alert-title': {
    margin: 0,
    fontSize: '$md',
    fontWeight: 'bold',

    '@media (max-width: 464px)': {
      fontSize: '$sm',
    },
  },

  '.abyss-alert-children-container': {
    fontSize: '$sm',
    fontWeight: '600',
  },

  '.abyss-link-root': {
    fontSize: '$sm',
    fontWeight: '600',
  },

  '.abyss-button-content-container': {
    fontWeight: 'bold',
  },
});

export const ChooseAsPCPButton = styled(Button, {
  top: '4px',
  fontSize: '$md',
  fontWeight: '600',
});
